import React from "react";

import { LucideIcon } from "lucide-react";

import "./KeyFeatures.scss";

interface Feature {
  icon: LucideIcon;
  title: string;
  description: string;
}

interface KeyFeaturesProps {
  title?: string;
  description?: string;
  features: Feature[];
}

export function KeyFeatures({
  title,
  description,
  features,
}: KeyFeaturesProps) {
  return (
    <section className="keyFeatures">
      <div className="featuresContainer">
        <div className="featuresHeader">
          <h2 className="featuresTitle">{title}</h2>
          <p className="featuresDescription">{description}</p>
        </div>
        <div className="featuresGrid">
          {features.map((feature, index) => (
            <div key={index} className="featureCard">
              <div className="featureIconWrapper">
                <feature.icon className="featureIcon" />
              </div>
              <h3 className="featureTitle">{feature.title}</h3>
              <p className="featureDecription">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
